var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/vi/lorem/index.js
 ** module id = 1167
 ** module chunks = 0
 **/